import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { IDropdownOptions, SharedDataService } from '../../../../../@core/service/shared-data.service';
import { NrkWindowComponent } from '../../../shared/nrk-window/nrk-window.component';
import { EBoxStatus, SpoBoxModel } from '../../../../../@models/erp/spoBox';
import { TreeService } from '../../../../../@core/service/tree.service';
import { EventService } from '../../../../../@core/service/eventService';
import { CompilationModel, PackingConditionItem, PackingConditions } from '../../../../../@models/erp/compilation';
import { ApiService } from '../../../../../@core/service/api.service';
import { ICheckboxChangeWithEvent } from '../../../shared/doc-form-checkbox/doc-form-checkbox.component';
import { LineItemModel } from '../../../../../@models/erp/lineItem';
import { nrkPad } from '../../../../../@core/common/global';
import { FinishedProductModel } from '../../../../../@models/erp/finishedProduct';

export interface IPackingWizardData {
  finalPacking: any[];
  sortOrder: number;
  selected: SpoBoxModel[];
  boxes: SpoBoxModel[];
  pallet: PackingConditions;
}

@Component({
  selector: 'ngx-packing-wizard',
  templateUrl: './packing-wizard.component.html',
  styleUrls: ['./packing-wizard.component.scss']
})
export class PackingWizardComponent implements OnInit, OnDestroy {

  @Input() compilation: CompilationModel;
  @Input() pallet: PackingConditions = null;
  @Input() warehousing = false;
  @Output() resultChange: EventEmitter<IPackingWizardData> = new EventEmitter<IPackingWizardData>();

  @ViewChild(NrkWindowComponent) window: NrkWindowComponent;

  BoxStatusType = EBoxStatus;

  page = 0;
  pages = 3;

  subscriptions = [];

  validBoxTypes = [];
  finalPackingOptions: any;

  result: IPackingWizardData = {} as IPackingWizardData;

  productionLotTable = [];

  spoBoxes: SpoBoxModel[] = [];

  filter = { // TODO: ?

  };

  numPallets = 0;
  palletIdx = 0;

  lineItem: LineItemModel;
  // finishedProduct: FinishedProductModel;

  constructor(private data: SharedDataService, protected tree: TreeService, private event: EventService, private api: ApiService) {}

  ngOnInit(): void {

    this.data.loadCompilationData();

    this.lineItem = this.compilation.lineItems[0];

    // this.subscriptions.push(this.tree.documentTreeLoadedEvent.subscribe(() => this.initProductionTable() ))
    // this.subscriptions.push(this.event.reloadBoxes.subscribe(() => this.initProductionTable() ))

    if (this.pallet) {
      // detect sort order
      const boxes = this.pallet.items.map(m => m.boxes).flat();
      this.result.sortOrder = boxes[0] > boxes[1] ? -1 : 1;
      // detect pallet data
      this.numPallets = this.compilation.packingConditions.filter(f => f.lineItemIdx === this.palletIdx).length;
      this.palletIdx = this.compilation.packingConditions.findIndex(f => f.lineItemIdx === this.pallet.lineItemIdx);
    } else {
      this.result.sortOrder = -1;
    }

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  async initProductionTable() {
    // console.log('init production',this.compilation, this.compilation.lineItems, this.compilation.lineItems.map(li => li.pfspo.map(m => m.code)));
    this.productionLotTable = [];
    this.spoBoxes = [];

    // this.data.boxesAreLoading.push(true);
    this.data.boxesAreLoading(true);
    
    for (let li of this.compilation.lineItems.filter(f => f.position.internalPos === this.lineItem.position.internalPos)) {
      for (let spo of li.pfspo) {
        let boxes, lineItem;
        await Promise.all([
          this.api.loadSpoBoxes({ spo: spo.code, status: { $gt: 0 } }).then(b => boxes = b),
          this.api.loadCompilationByCode(spo.code).then(c => lineItem = c.lineItems.find((f, idx) => {
            // console.log('init production find index', f.position?.internalPos, spo.internalPos, idx, spo.pos, li.position.internalPos);
            // return spo.pos === idx+1}
            // return spo.parentPos === idx
            if (spo.internalPos !== undefined) {
              return spo.internalPos === f.position.internalPos;
            } else {
              // legacy
              return spo.pos === idx+1;
            }
          }))
        ])

        // console.log('init production boxes, lineItem', boxes.length, lineItem?.boxDetails);

        boxes
          ?.filter(f => f.docRef === this.compilation.code && f.docRefPos === this.lineItem.position.internalPos)
          ?.sort((a, b) => (+a.case) - (+b.case))
          ?.map((box: SpoBoxModel) => {
          // if (!this.pallet || (this.pallet && (box.palletRef === this.pallet.palId || !box.palletRef))) {
            // if (!box.docRef && box.status === EBoxStatus.assignedPallet) box.status = EBoxStatus.assignedSpo;
            this.spoBoxes[box.boxId] = box;
            if (!this.spoBoxes[box.boxId].boxType) this.spoBoxes[box.boxId].boxType = lineItem?.boxDetails?.filter(f => f.case === box.case)[0]?.boxType; // legacy: TODO: remove
            // console.log('boxstat', box.status, EBoxStatus.assignedSpo, box.status > EBoxStatus.assignedSpo);
            this.productionLotTable?.push({
              selected: box.status === EBoxStatus.assignedPallet,
              boxId: box.boxId,
              status: box.status,
              // locked: box.status > EBoxStatus.assignedSpo,
              spo: spo.code,
              pos: spo.pos,
              case: box.case,
              lot: lineItem?.boxDetails?.filter(f => f.case === box.case)?.map(m => m.lot).join(', '),
              tc: lineItem?.boxDetails?.filter(f => f.case === box.case)?.map(m => m.tc?.split(',')?.map((it: any) => it.trim()))?.join(', '),
              quantity: box.quantity,
              weight: box.weight,
              boxType: lineItem?.boxDetails?.filter(f => f.case === box.case)[0]?.boxType,
              palletId: box.palletRef,
            })
          // }
        })

      }
    }

    this.validBoxTypes = Array.from(new Set(this.productionLotTable.map(m => m.boxType)));
    // console.log('valid box types', this.productionLotTable, this.validBoxTypes, this.lineItem.boxDetails);
    const rows = this.data.compilationData?.packingStore
      ?.find(f => f.id === 'finalPacking')?.data
      ?.filter(f => this.validBoxTypes.includes(f.cartonBox))
      ?.sort((a, b) => a.cartonBox.localeCompare(b.cartonBox))

    // console.log('initProductionTable packingStore', this.validBoxTypes, rows, this.data.compilationData?.packingStore, this.productionLotTable);

    this.finalPackingOptions = [];
    this.result.finalPacking = [];
    const fp = this.lineItem.finishedProduct;
    rows.forEach(row => {

      if (fp.packingSpec?.includes(row.id)) {
        row.fp = true;
        this.result.finalPacking[row.cartonBox] = row;
      }

      if (!this.finalPackingOptions[row.cartonBox]) {
        this.finalPackingOptions[row.cartonBox] = [];
        this.result.finalPacking[row.cartonBox] = row;
      }
      if (row.id === fp?.packing) {
        this.result.finalPacking[row.cartonBox] = row;
      }
      this.finalPackingOptions[row.cartonBox].push(row);
    })

    // console.log('production lot table', this.result.finalPacking, this.productionLotTable.length, this.productionLotTable);

    // this.data.boxesAreLoading.pop();
    this.data.boxesAreLoading();

    // Promise.all(this.compilation.lineItems.filter(f => f.position.internalPos === this.lineItem.position.internalPos).map(li => {
    //   return li.pfspo?.map(async spo => {
    //     const boxes = await this.api.loadSpoBoxes({ spo: spo.code, status: { $gt: 0 } });
    //     // console.log('boxes lenth', boxes, { spo: spo.code, status: { $gt: 0 } })
    //     return boxes?.filter(f => f.docRefPos === this.lineItem.position.internalPos)?.map(box => {
    //       if (!this.pallet || (this.pallet && (box.palletRef === this.pallet.palId || !box.palletRef))) {
    //         this.spoBoxes[box.boxId] = box;
    //         // console.log('boxstat', box.status, EBoxStatus.assignedSpo, box.status > EBoxStatus.assignedSpo);
    //         this.productionLotTable?.push({
    //           selected: box.status === EBoxStatus.assignedPallet,
    //           boxId: box.boxId,
    //           status: box.status,
    //           locked: box.status > EBoxStatus.assignedSpo,
    //           spo: spo.code,
    //           pos: spo.pos,
    //           case: box.case,
    //           lot: spo.docLineItem?.boxDetails?.filter(f => f.case === box.case)?.map(m => m.lot),
    //           tc: spo.docLineItem?.boxDetails?.filter(f => f.case === box.case)?.map(m => m.tc),
    //           quantity: box.quantity,
    //           weight: box.weight,
    //           boxType: spo.docLineItem?.boxDetails?.filter(f => f.case === box.case)[0]?.boxType,
    //         })
    //         // console.log('produ', this.productionLotTable.length);
    //       }
    //     })
    //   })
    // }).flat()).then(() => {

    //   this.validBoxTypes = Array.from(new Set(this.productionLotTable.map(m => m.boxType)));
    //   const rows = this.data.compilationData?.packingStore
    //     ?.find(f => f.id === 'finalPacking')?.data
    //     ?.filter(f => this.validBoxTypes.includes(f.cartonBox))
    //     ?.sort((a, b) => a.cartonBox.localeCompare(b.cartonBox))

    //   this.finalPackingOptions = [];
    //   this.result.finalPacking = [];
    //   const fp = this.lineItem.finishedProduct;
    //   rows.forEach(row => {
    //     if (!this.finalPackingOptions[row.cartonBox]) {
    //       this.finalPackingOptions[row.cartonBox] = [];
    //       this.result.finalPacking[row.cartonBox] = row;
    //     }
    //     if (row.id === fp?.packing) {
    //       this.result.finalPacking[row.cartonBox] = row;
    //     }
    //     this.finalPackingOptions[row.cartonBox].push(row);
    //   })

      
    //   console.log('production lot table', this.productionLotTable, this.validBoxTypes, this.finalPackingOptions, fp);
    // })
    
  }

  getProductionLotTable() {
      return this.productionLotTable;
      // return this.productionLotTable.filter(f => {
      //   if (this.pallet) {
      //     return f.palletId === this.pallet.palId || f.status === EBoxStatus.assignedSpo;
      //   } else {
      //     return true;
      //   }

      // })
      // return !pallet || pallet.items.map(m => m.boxes).flat().includes(lot.boxId) || lot.status === EBoxStatus.assignedSpo || !lot.locked;

  }

  canEditBoxStatus(lot: any) {
    if (this.pallet) {
      return lot.palletId === this.pallet.palId || lot.status === EBoxStatus.assignedSpo
    } else {
      return true;
    }
  }


  lastSelectedIndex: number;
  onCheckboxChange(idx: number, change: ICheckboxChangeWithEvent) {
    console.log('onCheckboxChange (packing wizard)', idx, change, this.pallet)
    const event = change.event
    const shiftKey = event.shiftKey;
    if (!this.pallet) {
      this.pallet = new PackingConditions();
      this.pallet.items = [];
    }
    if (shiftKey && this.lastSelectedIndex !== undefined) {
      const startIndex = Math.min(this.lastSelectedIndex, idx);
      const endIndex = Math.max(this.lastSelectedIndex, idx);
      for (let i = startIndex; i <= endIndex; i++) {
        this.productionLotTable[i].selected = change.checked;
        this.productionLotTable[i].status = change.checked ? EBoxStatus.assignedPallet : EBoxStatus.assignedSpo;
        this.productionLotTable[i].palletId = change.checked ? this.pallet.palId : null;
        this.spoBoxes[this.productionLotTable[i].boxId].status = this.productionLotTable[i].status;
        this.spoBoxes[this.productionLotTable[i].boxId].palletRef = change.checked ? this.pallet.palId : null;
        
        if (this.pallet && change.checked) {
          this.pallet.items[0]?.boxes.push(this.productionLotTable[i].boxId);
        }
      }
    } else {
      this.productionLotTable[idx].status = change.checked ? EBoxStatus.assignedPallet : EBoxStatus.assignedSpo;
      this.productionLotTable[idx].palletId = change.checked ? this.pallet.palId : null;
      this.spoBoxes[this.productionLotTable[idx].boxId].status = this.productionLotTable[idx].status;
      this.spoBoxes[this.productionLotTable[idx].boxId].palletRef = change.checked ? this.pallet.palId : null;
      if (this.pallet && change.checked) {
        this.pallet.items[0]?.boxes.push(this.productionLotTable[idx].boxId);
      }
  }
    // console.log('on checkbox change', idx, this.productionLotTable.find(f => f.idx === idx), this.productionLotTable);
    this.lastSelectedIndex = idx;
  }

  selectAll(checked: boolean) {
    this.productionLotTable.forEach(el => {
      // if (!el.locked || this.isInPallet(el, this.pallet)) {
      if (this.canEditBoxStatus(el)) {
        el.selected = checked;
        el.status = checked ? EBoxStatus.assignedPallet : EBoxStatus.assignedSpo;
        this.spoBoxes[el.boxId].status = el.status;
        if (this.pallet) {
          el.palletId = checked ? this.pallet.palId : null;
          this.spoBoxes[el.boxId].palletRef = el.palletId;
        }
      }
      // console.log('selectAll', el.boxId, this.spoBoxes[el.boxId])
      // }
    })
  }

  markAs(status: EBoxStatus) {
    this.productionLotTable.forEach(el => {
      // if (!el.locked || this.isInPallet(el, this.pallet)) {
      if (this.canEditBoxStatus(el) && el.selected) {
        el.status = status;
      }
    })
  }

  // isInPallet(lot: any, pallet: PackingConditions) {
  //   // const hasBox = this.spoBoxes[lot.boxId].docRefPos === this.lineItem.position.internalPos;
  //   // return hasBox && (!pallet || pallet.items.map(m => m.boxes).flat().includes(lot.boxId) || lot.status === EBoxStatus.assignedSpo || !lot.locked);
  //   return !pallet || pallet.items.map(m => m.boxes).flat().includes(lot.boxId) || lot.status === EBoxStatus.assignedSpo || !lot.locked;
  // }

  getLotValue(lot) {
    // console.log('lllot1--->', lot.case, lot.selected, lot.status)
    return lot.selected;
  }
  getLotStatus(lot) {
    // console.log('lllot2--->', lot.case, lot.selected, lot.status)
    return true;
  }

  getSumBoxesQuantity(boxes: any) {
    if (typeof boxes?.filter !== 'function') {
      // TODO: boxes = {}
      console.error('getSumBoxesQuantity error', boxes);
      return;
    }
    const filtered = boxes?.filter(f => {
      // return f.status === EBoxStatus.assignedPallet && this.spoBoxes[f.boxId]?.docRefPos === this.lineItem.position.internalPos
      // console.log('getSumBoxQuantity', boxes, this.pallet?.palId, f.palletId, f.status === EBoxStatus.assignedPallet, f.status, this.pallet);
      return f.status === EBoxStatus.assignedPallet && ((!f.palletId && !this.pallet) || f.palletId === this.pallet?.palId)
    });

    return {
      boxes: filtered.length,
      quantity: filtered.reduce((a, c) => a + (+c.quantity), 0)
    }
  }
  

  open(lineItem: LineItemModel) {
    // console.log('open packing wizard')
    this.lineItem = lineItem;
    this.initProductionTable();
    this.page = this.pallet ? 1 : 0;
    this.window.show();
  }


  close() {
    // console.log('close packing wizard')
    this.window.hide();
  }


  back() {
    if (this.page > 0) this.page--;
  }


  next() {
    if (this.page < this.pages-1) this.page++;
  }


  async save() {

    // this.result.selected = this.productionLotTable
    //   .filter(f => !f.locked && f.status === EBoxStatus.assignedPallet && (!this.pallet || ['FPD1', 'FPD2'].includes(this.pallet.packingType) || this.pallet.items.map(m => m.boxes).flat().includes(f.boxId)))
    //   .map(m => this.spoBoxes[m.boxId])
    //   .sort((a, b) => +a.case > +b.case ? this.result.sortOrder : -this.result.sortOrder)
    //   .sort((a, b) => a.spo === b.spo ? 0 : a.spo.localeCompare(b.spo))

    // console.log('save pallet', this.pallet?.packingType, this.pallet, this.productionLotTable, this.spoBoxes);

    this.productionLotTable.forEach(el => {
      // this.spoBoxes[el.boxId].palletRef = el.palletId ? el.palletId : null;
      if (el.status < EBoxStatus.assignedPallet) {
        this.spoBoxes[el.boxId].palletRef = null;
      }
    })

    this.result.boxes = this.spoBoxes
      // .filter(f => f.status === EBoxStatus.assignedPallet && (!this.pallet || ['FPD0'].includes(this.pallet.packingType) || this.pallet.items.map(m => m.boxes).flat().includes(f.boxId)))
      .filter(f => f.status === EBoxStatus.assignedPallet && (this.pallet && this.pallet.palId === f.palletRef) || (!this.pallet || ['FPD0'].includes(this.pallet.packingType)))
      .map(m => { m.tc = m.tc.join(',').split(',').map(tc => tc.trim()); return m })
      .sort((a, b) => +a.case > +b.case ? this.result.sortOrder : -this.result.sortOrder)
      .sort((a, b) => a.spo === b.spo ? 0 : a.spo.localeCompare(b.spo))

    // console.log('save result boxes ', this.result.boxes);

    this.result.pallet = this.pallet;

    // console.log('this.result', this.result, this.spoBoxes);

    const sporesult = await this.api.saveSpoBoxes(this.spoBoxes.filter(notNull => notNull));

    // console.log('save result pallet', this.result, sporesult);

    // console.log('return data', this.result, sporesult, this.result.boxes);
    this.resultChange.emit(this.result);

    this.close();
  }

  getPacking(pallet) {
    if (!pallet) return '';
    const fp = this.data.getPackingConfig()?.finalPacking;
    return this.data.getPackingConfig()?.finalPacking?.find(f => f.id === pallet.packingType);
  }

}
